<div class="navigation-wrapper">
	
	<div class="navigation-container">
		
		<div class="logo-container">
			
			<div class="brand">Neatly Living</div>
		
		</div>
		
		<div class="navigation-items">
			
			<button [routerLinkActive]="['b-active']" class="nlv-btn link" routerLink="/home">Home</button>
			
			<button [routerLinkActive]="['b-active']" class="nlv-btn link" routerLink="/store">Store</button>
			
			<button [routerLinkActive]="['b-active']" class="nlv-btn link" routerLink="/consultation">Consultation</button>
		
		</div>
	
	</div>

</div>
